<div fxLayout id="property-details">
  <sbnb-subnav fxFlex="280px" fxHide.lt-md class="subnav__semi-reduced-padding">
    <sbnb-property-detail-subnav
      *ngIf="property"
      #propertyDetailSubnavComponent
      [activeComponent]="activeNavItem"
      [onboardingStatus]="onboardingStatus"
      [propertyMuted]="property.muted"
      [bookingListing]="property.counts.booking > 0"
      [canManageAvailability]="property.can_manage_availability"
      (navChanged)="setActiveComponent($event)"
      (onboardingChanged)="onboardingChange($event)"></sbnb-property-detail-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header
        navTabs
        [parentPath]="'properties/segments/default'"
        class="block sbnbDesktop:hidden"></sbnb-page-header>
    </app-feature-flag-tabs>

    <div class="flex flex-col gap-2 md:flex-row md:justify-between md:items-center pb-4">
      <h2 class="nomargin nopadding">{{ activeHeading }}</h2>
      <ng-container *ngIf="property">
        <sbnb-property-select-dropdown
          class="flex-1 max-w-[400px]"
          *ngIf="properties$ | async as properties"
          [properties]="properties"
          [showPlaceholder]="false"
          [selectedPropertyId]="property.id"
          (selectedPropertyChanged)="propertyChanged($event)"></sbnb-property-select-dropdown>
      </ng-container>
    </div>
    <div *ngIf="loading" class="table__no-items">Loading property details...</div>

    <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'property-detail'"></sbnb-helptext-wrapper>

    <ng-container *ngIf="property && !loading">
      <sbnb-property-detail-merge-match
        [hidden]="activeNavItem !== 'merge-match'"
        [property]="property"></sbnb-property-detail-merge-match>

      <sbnb-property-detail-details
        [hidden]="activeNavItem !== 'details'"
        [property]="property"></sbnb-property-detail-details>

      <sbnb-property-detail-direct
        [hidden]="activeNavItem !== 'direct'"
        [propertyId]="property.id"
        [propertySlug]="property.direct_site_slug"></sbnb-property-detail-direct>

      <div [hidden]="activeNavItem !== 'pricing'" class="mr-4">
        <sbnb-property-base-price
          *ngIf="property.counts?.airbnb > 0"
          [currency]="property.currency"
          [dynamicPricingEnabled]="property?.dynamic_pricing?.outbound_dynamic_pricing_enabled"
          [showDynamicPricingCTA]="true"></sbnb-property-base-price>
        <sbnb-property-listing-markups [property]="property"></sbnb-property-listing-markups>

        <sbnb-property-booking-rate-plans
          *ngIf="property.id && (permissionsService.isPrimaryUser() | async)"
          [propertyId]="property.id"
          [propertyCurrency]="property.currency"
          [propertyName]="property.name"></sbnb-property-booking-rate-plans>

        <sbnb-property-fees-taxes-discounts [property]="property"></sbnb-property-fees-taxes-discounts>
      </div>

      <sbnb-property-detail-payouts
        *ngIf="permissionsService.isPrimaryUser() | async"
        [hidden]="activeNavItem !== 'payouts'"
        [property]="property"></sbnb-property-detail-payouts>

      <sbnb-property-detail-messaging-rules
        [onboardingMode]="onboardingStatus"
        (onboardingChange)="onboardingChange($event)"
        [type]="activeNavItem"
        [hidden]="
          activeNavItem !== 'messaging-rules' &&
          activeNavItem !== 'review-rules' &&
          activeNavItem !== 'canned-responses' &&
          activeNavItem !== 'task-rules' &&
          activeNavItem !== 'team' &&
          activeNavItem !== 'notification-rules' &&
          activeNavItem !== 'custom-codes'
        "
        [property]="property"></sbnb-property-detail-messaging-rules>
      <ng-container *ngIf="activeNavItem === 'knowledge'">
        <sbnb-content-header
          [saveButtonShown]="false"
          [navigateBack]="false"
          novaContentId="property-detail-knowledge"
          [sticky]="false"></sbnb-content-header>
        <sbnb-knowledge [propertyId]="property.id"></sbnb-knowledge>
      </ng-container>
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [title]="'Property details'">
  <sbnb-property-detail-subnav
    *ngIf="property"
    #propertyDetailSubnavComponent
    [activeComponent]="activeNavItem"
    [onboardingStatus]="onboardingStatus"
    [propertyMuted]="property.muted"
    [bookingListing]="property.counts.booking > 0"
    [canManageAvailability]="property.can_manage_availability"
    (navChanged)="setActiveComponent($event)"
    (onboardingChanged)="onboardingChange($event)"></sbnb-property-detail-subnav>
</sbnb-mobile-sidebar>
